var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/home/circleci/project/@static/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["@modules/modals/templates/image-view.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"modal-inner-container ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsSize"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsPadding"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsBackgroundColor"), env.opts.autoescape);
output += "\">\n    <button class=\"modal__close-btn btn\" data-js-ui=\"close-modal\">\n        <span class=\"modal__close-btn-label\" data-auto-translate=\"true\">Close</span>\n        <span class=\"modal__close-btn-icon icon-close\"></span>\n    </button>\n    <div class=\"modal__timeline-container\">\n        <div class=\"container-fluid\">\n            <div class=\"row\">\n                <div class=\"col-sm-12\">\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "jsImg")) {
output += "\n                        <img class=\"timeline-image\" src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsImg"), env.opts.autoescape);
output += "\" />\n                    ";
;
}
output += "\n                    <h6 class=\"gallery--timeline__label\" data-auto-translate=\"true\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("deunicode").call(context, runtime.contextOrFrameLookup(context, frame, "jsTitle"))), env.opts.autoescape);
output += "</h6>\n                    <div class=\"modal__text rich-text\" data-auto-translate=\"true\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("deunicode").call(context, runtime.contextOrFrameLookup(context, frame, "jsText"))), env.opts.autoescape);
output += "</div>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["@modules/modals/templates/image-view.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./@modules/modals/templates/image-view.njk
// module id = 488
// module chunks = 0